module.exports = __webpack_public_path__ + "img/timeline-xl-en.fc1a75f8.jpg";